import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import HeaderOptions from 'components/HeaderOptions';
import ListHeaderTopRightOptions from './components/ListHeaderTopRightOptions';

const ListHeaderOptions = ({
  searchTerm,
  items,
  modelName,
  onMergeImport,
  onReplaceImport,
  onExport,
  getItems,
  openNewModal,
  bottomRightOptions,
  displayTrainButton,
  onTrain,
}) => (
  <HeaderOptions
    bottomRightOptions={bottomRightOptions}
    modelName={modelName}
    topRightOptions={
      <ListHeaderTopRightOptions
        displayTrainButton={displayTrainButton}
        getItems={getItems}
        items={items}
        modelName={modelName}
        openNewModal={openNewModal}
        searchTerm={searchTerm}
        onExport={onExport}
        onMergeImport={onMergeImport}
        onReplaceImport={onReplaceImport}
        onTrain={onTrain}
      />
    }
  />
);

ListHeaderOptions.propTypes = {
  ...ListHeaderTopRightOptions.propTypes,
  bottomRightOptions: PropTypes.node,
  displayTrainButton: PropTypes.bool,
  onTrain: PropTypes.func,
};

ListHeaderOptions.defaultProps = {
  bottomRightOptions: null,
  displayTrainButton: false,
  onTrain: noop,
};

export default ListHeaderOptions;
